// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ConfirmPhoneVerificationMutation($input: ConfirmPhoneVerificationInput!) {
    confirmPhoneVerification(input: $input) {
      user {
        id
        phone
        phoneVerified
        twoFactorEnabled
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
